import stylesheet from './TextCardGroup.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTTextCardGroup extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get variant() {
        return this.getAttribute('variant') ?? 'scroll';
    }

    getTextCardBreakpointVariants(): string[] {
        const additionalClasses: string[] = [];
        let previousVariant = this.variant;
        for (const breakpoint of ['md', 'lg', 'xl', 'xxl']) {
            const attributeName = `variant-${breakpoint}`;
            if (this.hasAttribute(attributeName)) {
                additionalClasses.push(`variant-${this.getAttribute(attributeName)}-${breakpoint}-only`);
                previousVariant = this.getAttribute(attributeName);
            } else {
                additionalClasses.push(`variant-${previousVariant}-${breakpoint}-only`);
            }
        }
        return additionalClasses;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            'text-card-group',
            `variant-${this.variant}-sm-only`,
            ...this.getTextCardBreakpointVariants(),
        );
        const scrollContainer = document.createElement('div');
        scrollContainer.classList.add('scroll-container');
        const imageCardContainer = document.createElement('div');
        imageCardContainer.classList.add('items');
        scrollContainer.appendChild(imageCardContainer);
        container.appendChild(scrollContainer);
        this.cloneDefaultSlotContentIntoContainer(imageCardContainer);
        return container;
    }

}

customElements.define('nxt-text-card-group', NXTTextCardGroup);
